module.exports = __webpack_public_path__ + "media/flags/008-saudi-arabia-4ebeb22c.svg";